import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const store = (path) => ({
  namespaced: true,
  state: {
    isDownloading: false,

    //Datasource
    isDatasourceInventoryLoading: false,
    datasourceInventory: undefined,
    //Data
    isDataInventoryLoading: false,
    dataInventory: undefined,
    //Datasubject
    isDatasubjectInventoryLoading: false,
    datasubjectInventory: undefined,
  },
  getters: {
    isDownloading: (state) => state.isDownloading ?? {},

    //Datasource
    datasourceInventory: (state) => state.datasourceInventory ?? {},
    isDatasourceInventoryLoading: (state) => state.isDatasourceInventoryLoading,
    //Datasubject
    datasubjectInventory: (state) => state.datasubjectInventory ?? {},
    isDatasubjectInventoryLoading: (state) => state.isDatasubjectInventoryLoading,
    //Datasubject
    dataInventory: (state) => state.dataInventory ?? {},
    isDataInventoryLoading: (state) => state.isDataInventoryLoading,
  },
  mutations: {
    isDownloading: (state, value) => (state.isDownloading = value),

    //Datasource
    isDatasourceInventoryLoading: (state, value) => (state.isDatasourceInventoryLoading = value),
    datasourceInventory: (state, value) => (state.datasourceInventory = value),
    removeDirectCollectMethod: (state, value) => {
      const { datasourceId, directCollectMethodId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.directCollectMethods = ds.directCollectMethods.filter((i) => i._id != directCollectMethodId);
      }
    },
    removeOtherCollectMethod: (state, value) => {
      const { datasourceId, otherCollectMethodId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.otherCollectMethods = ds.otherCollectMethods.filter((i) => i._id != otherCollectMethodId);
      }
    },
    removePhysicalArchive: (state, value) => {
      const { datasourceId, physicalArchiveId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.physicalArchives = ds.physicalArchives.filter((i) => i._id != physicalArchiveId);
      }
    },
    removeElectronicArchive: (state, value) => {
      const { datasourceId, electronicArchiveId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.electronicArchives = ds.electronicArchives.filter((i) => i._id != electronicArchiveId);
      }
    },

    removePhysicalStorage: (state, value) => {
      const { datasourceId, physicalStorageId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.physicalStorages = ds.physicalStorages.filter((i) => i._id != physicalStorageId);
      }
    },
    removeElectronicStorage: (state, value) => {
      const { datasourceId, electronicStorageId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.electronicStorages = ds.electronicStorages.filter((i) => i._id != electronicStorageId);
      }
    },

    //Datasubject
    isDatasubjectInventoryLoading: (state, value) => (state.isDatasubjectInventoryLoading = value),
    datasubjectInventory: (state, value) => (state.datasubjectInventory = value),

    removeTransfering: (state, value) => {
      const { datasubjectId, transferingId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.transferings = ds.transferings.filter((i) => i._id != transferingId);
      }
    },

    removeProcessingLegal: (state, value) => {
      const { datasubjectId, processingLegalId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.processingLegals = ds.processingLegals.filter((i) => i._id != processingLegalId);
      }
    },

    removeProcessingPurpose: (state, value) => {
      const { datasubjectId, processingPurposeId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.processingPurposes = ds.processingPurposes.filter((i) => i._id != processingPurposeId);
      }
    },
    removeDatasubjectDatasubjectRigth: (state, value) => {
      const { datasubjectId, datasubjectDatasubjectRightId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.datasubjectRights = ds.datasubjectRights.filter((i) => i._id != datasubjectDatasubjectRightId);
      }
    },

    //Data
    isDataInventoryLoading: (state, value) => (state.isDataInventoryLoading = value),
    dataInventory: (state, value) => (state.dataInventory = value),

    removeDisposalMethod: (state, value) => {
      const { dataId, disposalMethodId } = value;
      const d = state.dataInventory[dataId];
      if (d) {
        d.disposalMethods = d.disposalMethods.filter((i) => i._id != disposalMethodId);
      }
    },
    removeAccessAndRestriction: (state, value) => {
      const { dataId, accessAndRestrictionId } = value;
      const d = state.dataInventory[dataId];
      if (d) {
        d.accessAndRestrictions = d.accessAndRestrictions.filter((i) => i._id != accessAndRestrictionId);
      }
    },
  },
  actions: {
    async fetchDatasourceInventory({ commit }, payload) {
      commit("isDatasourceInventoryLoading", true);
      try {
        const response = await rest.post(`${path}/fetch-datasource`, payload);
        commit("datasourceInventory", response.data);
        return response;
      } finally {
        commit("isDatasourceInventoryLoading", false);
      }
    },
    async fetchDatasubjectInventory({ commit }, payload) {
      commit("isDatasubjectInventoryLoading", true);
      try {
        const response = await rest.post(`${path}/fetch-datasubject`, payload);
        commit("datasubjectInventory", response.data);
        return response;
      } finally {
        commit("isDatasubjectInventoryLoading", false);
      }
    },
    async fetchDataInventory({ commit }, payload) {
      commit("isDataInventoryLoading", true);
      try {
        const response = await rest.post(`${path}/fetch-data`, payload);
        commit("dataInventory", response.data);
        return response;
      } finally {
        commit("isDataInventoryLoading", false);
      }
    },

    async download({ commit }, saveInsteadofDownload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post(`${path}/download`, { saveInsteadofDownload });
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
    async downloadDiff({ commit }, { saveInsteadofDownload, source, target }) {
      commit("isDownloading", true);
      try {
        const response = await rest.post(`${path}/diff/download`, { saveInsteadofDownload, source, target });
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
  },
});

export const kvkkInventory = createCrudVuexModule({
  ...store("/kvkk/inventory"),
  path: "/kvkk/inventory",
});

export const gdprInventory = createCrudVuexModule({
  ...store("/gdpr/inventory"),
  path: "/gdpr/inventory",
});
